import { get } from 'common/utils/xhr';
import createScrollableElements, {
    centerAlignScrollableElement,
    scrollOnHover,
} from 'marketing/components/scrollable';
import { findParentByAttribute } from 'common/utils/domUtils';
import FullscreenOverlay from 'marketing/components/FullscreenOverlay';

export default class FeaturedContestInspiration {
    constructor() {
        this.allDesignsContainer = document.querySelector(
            '[data-featured-contest-inspiration-designs]'
        );
        this.loading = document.querySelector(
            '[data-featured-contest-inspiration-designs-loading]'
        );
        this.showAll = 'false';
        this.fullscreenOverlayElement = document.querySelector(
            '[data-fullscreen-overlay-id="featured-contest-design-inspiration-modal"]'
        );
        this.industrySelect = document.getElementById(
            'featured-contest-design-inspiration-industry-select'
        );
        this.showMoreButton = document.querySelector('[data-extra-inspiration-button]');

        this.initialiseDesigns();

        if (this.industrySelect) {
            this.initialiseIndustryDropdown();
        }
    }

    initialiseDesigns() {
        if (this.fullscreenOverlayElement) {
            this.initialiseFullScreenOverlay();
        }

        if (this.allDesignsContainer) {
            this.initialiseModalContent();
        }

        if (this.showMoreButton) {
            this.initialiseShowMoreButton();
        }
    }

    initialiseShowMoreButton() {
        let extraDesigns = document.querySelector('[data-extra-inspiration-designs]');
        let discoverLink = document.querySelector('[data-extra-inspiration-discover-link]');

        this.showMoreButton.addEventListener('click', () => {
            this.showMoreButton.setAttribute('data-hidden', true);
            if (extraDesigns) {
                extraDesigns.removeAttribute('data-hidden');
            }
            if (discoverLink) {
                discoverLink.removeAttribute('data-hidden');
            }
            this.showAll = 'true';
        });
    }

    initialiseModalContent() {
        const designs = this.allDesignsContainer.querySelectorAll('[data-fullscreen-overlay-open]');

        for (const design of designs) {
            design.addEventListener('click', () => {
                this.setModalContent(design);
            });
        }
    }

    initialiseFullScreenOverlay() {
        new FullscreenOverlay({
            element: this.fullscreenOverlayElement,
            options: {
                fixedViewport: true,
            },
        });
    }

    initialiseIndustryDropdown() {
        this.industrySelect.addEventListener('change', e => {
            this.startLoading();

            const xhr = get(
                `/start/xhr/inspiration-designs/${e.target.value}?show_all=${this.showAll}`
            );
            xhr.end((error, res) => {
                if (error) {
                    this.stopLoading();
                } else {
                    this.allDesignsContainer.innerHTML = res.body.html;
                    this.initialiseDesigns();
                    this.runScrollable();
                    this.stopLoading();
                }
            });
        });
    }

    setModalContent(design) {
        const modalElement = this.fullscreenOverlayElement.querySelector(
            '[data-fullscreen-overlay-modal-content]'
        );
        const modalContentContainer = design.querySelector('[data-modal-content-container]');
        const modalImageElement = modalContentContainer.querySelector('[data-modal-image]');
        const modalImageSrc = modalImageElement.getAttribute('data-image-src');

        modalImageElement.setAttribute('src', modalImageSrc);
        modalElement.innerHTML = modalContentContainer.innerHTML;
    }

    startLoading() {
        this.loading.removeAttribute('data-hidden');
    }

    stopLoading() {
        this.loading.setAttribute('data-hidden', '');
    }

    runScrollable() {
        createScrollableElements();
        scrollOnHover('[data-scrollable="examples"]');
        centerAlignScrollableElement('[data-scrollable="examples"]');
    }

    getDefaultTrackingData(node) {
        const parent = findParentByAttribute(node, 'data-trackable-section');
        const sectionId = parent ? parent.getAttribute('data-trackable-section') : null;

        return Object.assign({}, global.trackParams, {
            section_id: sectionId,
        });
    }
}
